import api_fabric from "../../api/ApiFabric";
/**
 *
 * @return {Stats}
 */

const api = function() {
  return api_fabric.getInstance("Stats", true);
};

const stats = {
  namespaced: true,
  state: {
    stats_data: null,
  },
  mutations: {
    writeStatsData(state, data) {
      state.stats_data = data;
    },
  },
  getters: {
    getStatsData(state) {
      return state.stats_data;
    },
  },
  actions: {
    requestStatsData({ commit }) {
      return new Promise(resolve => {
        api()
          .getStatsData()
          .then(response => {
            if (response.success) {
              commit("writeStatsData", response.success.data.data);
              resolve();
            }
          });
      });
    },
  },
};

export default stats;
